import tables from './tables';
import utils from '../utils';

const getProductById = async (productId, token) => {
  try {
    const { data: product } = await utils.getFromMikMakFirebaseService(
      `getById/${tables.products_v2}/${productId}`,
      token,
    );

    return product;
  } catch (e) {
    throw `Error getting saved product`;
  }
};

const setProduct = async (product, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `set/${tables.products_v2}/${product.id}`,
      product,
      token,
    );

    return product;
  } catch (e) {
    throw `Error saving video to product assets: ${e}`;
  }
};

const setProductOptions = async (productId, options, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `update/${tables.products_v2}/${productId}`,
      { options: options },
      token,
    );

    return options;
  } catch (e) {
    throw `Error saving video to product assets: ${e}`;
  }
};

const setProductReferenceToPlayer = async (productId, playerId, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `update/${tables.productPlayers}/${productId}`,
      { [playerId]: true },
      token,
    );
  } catch (e) {
    throw `error setting player on product`;
  }
};

const removeProductReferenceToPlayer = async (productId, playerId, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `remove/${tables.productPlayers}/${productId}/${playerId}`,
      token,
    );
  } catch (e) {
    throw `error removing player on product`;
  }
};

export default {
  getProductById,
  setProduct,
  setProductOptions,
  setProductReferenceToPlayer,
  removeProductReferenceToPlayer,
};
